import dayjs from 'dayjs'

const orgin = d => {
  return dayjs(d)
}

export default {
  install (Vue, options) {
    Vue.prototype.$date = {
      orgin
    }
  }
}
